<template>
    <div>
        <div class="container-fluid white-bg centers-list">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / <a href="/home-teacher/onlineteacher">ONLINETeacher</a> /
                            Preschool English 1
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h1 class="strongh1">Preschool English 1. Английский для начинающих</h1>
                        <p class="px18">Курс групповых онлайн-занятий по программе «Preschool English 1» разработан
                            специально для детей от 3 до 8 лет, не знакомых с английским языком. Хотите, чтобы ваш
                            ребёнок освоил английский легко, без спешки и напряжения? Тогда этот курс вам подходит!</p>

                        <p class="px18"><span class="strong-black">Пройдя обучение, ребёнок  играючи освоит <span
                                class="strong-red">420 слов</span> на новом языке, научится понимать английскую речь и вести простой диалог с преподавателем.</span>
                        </p>


                        <p>&nbsp;</p>
                        <h3 class="redh3" style="text-align: center; margin-bottom: 30px;">Вместе мы изучим:</h3>
                      <div class="indivurok"><div class="urk">названия игрушек</div></div>
                      <div class="indivurok"><div class="urk">предметы в доме</div></div>
                      <div class="indivurok"><div class="urk">предметы гардероба</div></div>
                      <div class="indivurok"><div class="urk">дни недели и месяцы</div></div>
                      <div class="indivurok"><div class="urk">транспорт</div></div>
                      <div class="indivurok"><div class="urk">продукты питания</div></div>
                      <div class="indivurok"><div class="urk">названия животных</div></div>
                    </div>
                </div>
            </div>
        </div>
       <!-- <div class="container-fluid white-bg centers-list razuchim no-shadow">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="skill-wrapper">
                            <div class="skill-text skill-text-1"><span>названия игрушек</span></div>
                            <div class="skill-text skill-text-2"><span>предметы в доме</span></div>
                            <div class="skill-text skill-text-3"><span>предметы гардероба</span></div>
                            <div class="skill-text skill-text-4"><span>дни недели и месяцы</span></div>
                            <div class="skill-text skill-text-5"><span>транспорт</span></div>
                            <div class="skill-text skill-text-6"><span>продукты питания</span></div>
                            <div class="skill-text skill-text-7"><span>названия животных</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

        <div class="container-fluid white-bg centers-list no-shadow">
            <div class="container align-middle">
                <div class="row" style="margin-top: 20px;">
                    <div class="col-12">
                        <p class="px18"><span class="strong-green">Дети с большим интересом узнают новые слова и стремятся использовать их на
                            практике!</span></p>
                        <p class="px18">Уроки на платформе OnlineTeacher проводятся профессиональными педагогами в
                            режиме реального времени. Мы обучаем через Интернет, а значит, ваш ребёнок может заниматься
                            где угодно: дома, в машине и даже на даче при помощи обычного смартфона, или планшета. Всё,
                            что вам потребуется, это устойчивая связь (от 1 Мбит/сек) и хороший микрофон.</p>
                        <p class="px18"><span class="strong-black">Занятия с Полиглотиками &ndash; это чудесная возможность интересно и весело провести время, пообщаться с другими детьми и получить полезные навыки. Подключайтесь к нашим урокам!</span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                src="https://www.poliglotiki.ru/embed/42MC62cDy00" frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <TimetableStatic id="6440"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="redh2">Всё о курсе</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-10">

                        <p class="px18"><span class="strong-black">Программа курса «Английский для начинающих» создавалась методистами Полиглотиков  с учётом новейших открытий в области  нейропедагогики и нейропсихологии. Цикл занятий выстроен таким образом, что ваш ребёнок может начать обучение в любой момент, и вам  не придётся догонять группу!</span>
                        </p>
                        <p class="px18">Наши уроки проходят по расписанию, как и в обычной школе. Основным предметом в
                            программе является <span class="strong-blue">Preschool English 1</span>, он рекомендуется
                            для обязательного посещения 2-3 раза в неделю.
                            Занятия по остальным предметам &ndash; <span
                                    class="strong-blue">Art Class, Music Class</span> и <span class="strong-blue">Story Time</span>
                            являются дополнительными. Их можно посещать от 1 до 5 раз в неделю, исходя из ваших личных
                            симпатий и предпочтений.</p>
                    </div>
                    <div class="col-12 col-sm-2 about-center">
                        <a href="@/assets/hometeacher/images/preschool-english-sertif.jpg" target="_blank"><img
                                src="@/assets/hometeacher/images/preschool-english-sertif-small.jpg"
                                alt="Английский для начинающих" class="sertifikat"></a>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 col-sm-10">

                        <p class="px18"><span class="strong-black">Онлайн-занятия от Пролиглотиков разработаны специально для дошкольников с учётом их возрастных особенностей. Каждый урок длится не более </span>
                            <span class="strong-red">45 минут</span> <span class="strong-black">, включая обязательную разминку, гимнастику для глаз и время для обратной связи. В конце  занятия у вас есть</span>&nbsp;<span
                                    class="strong-red">5 минут</span>&nbsp;<span class="strong-black">для того,
                    чтобы поговорить с педагогом, задать вопросы об успехах ребёнка и получить рекомендации.</span></p>
                        <p class="px18">Если у родителей есть важные дела, им не обязательно присутствовать на уроках.
                            После первых занятий вы можете смело доверить ребёнка заботе наших преподавателей. Педагоги
                            центра Полиглотики проходят обучение специальной методике &ndash; используя смену различных
                            интересных занятий в ходе урока, они мастерски удерживают внимание даже самых маленьких
                            детей.</p>
                    </div>
                    <div class="col-12 col-sm-2 about-center">
                        <a href="@/assets/hometeacher/images/preschool-english-sertif-2.jpg" target="_blank"><img
                                src="@/assets/hometeacher/images/preschool-english-sertif-2-small.jpg"
                                alt="Английский для начинающих" class="sertifikat" style="margin-top:20px;"></a>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-12">
                        <CourseStatic id="34"/>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="container-fluid blue-wave-top" style="margin-top: -7px;"></div>
        <div class="container-fluid grey-bg no-shadow" style="text-align:left;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="land-t-h2" style="margin-bottom: 40px; text-align: center;">Наши преподаватели</h2>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4 centers-text">
                        <a href=""><img src="@/assets/hometeacher/images/rami.jpg" alt="Rami Al-Rasheed"
                                        class="teacher-krug"></a>
                        <div class="teacher-name"><a href="" target="_blank">Rami Al-Rasheed</a></div>
                        <div class="speach">Привет! Я учитель английского и арабского в Полиглотиках. Сейчас изучаю
                            русский язык.
                            Я работал в волонтерской миссии в Сирии и Пакистане, мы обучали детей из маленьких сел
                            английскому языку.
                            В России я уже два года, работаю онлайн с школьниками и дошкольниками. Пою в церковном хоре,
                            занимаюсь благотворительностью.
                            Я люблю детей и хочу научить их всему лучшему, что во мне есть. Мои уроки всегда
                            разнообразные и интересные.
                            Давайте учить английский вместе!
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 centers-text">
                        <a href="https://poliglotiki.com/kobzeva-viktoriya.html" target="_blank"><img
                                src="@/assets/hometeacher/images/kobzeva.jpg" alt="Кобзева Виктория"
                                class="teacher-krug"></a>
                        <div class="teacher-name"><a href="https://poliglotiki.com/kobzeva-viktoriya.html"
                                                     target="_blank">Виктория Кобзева</a></div>
                        <div class="speach">Я преподаватель языковой студии «Полиглотики» в г. Ставрополе. Я имею высшее
                            лингвистическое образование,
                            а также двухлетний стаж работы в данной сфере. С искусством моя жизнь связана давно. Я
                            закончила художественную школу и стала
                            проходить различные курсы по живописи акварелью и маслом от современных художников.
                            Сейчас я уже сама провожу интересные мастер-классы не только на русском, но и на английском
                            языке, доступные взрослым и детям
                            любых возрастов. Буду рада видеть Вас на своих занятиях!
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 centers-text">
                        <a href=""><img src="@/assets/hometeacher/images/semyonova.jpg" alt="Анастасия Семёнова"
                                        class="teacher-krug"></a>
                        <div class="teacher-name"><a href="" target="_blank">Анастасия Семёнова</a></div>
                        <div class="speach">Hello everyone! Меня зовут Анастасия, я преподаватель центра «Полиглотики».
                            Английский сопровождает меня на протяжении всей жизни с 6 лет. Я влюбилась в этот язык!
                            Особенно мне нравится изучать современный разговорный английский, ведь именно язык и стиль
                            речи быстро меняются с течением времени, и знания по ним постоянно нужно обновлять. 2 года
                            практики ведения занятий в онлайн-формате дали мне огромную базу для проведения интересных и
                            захватывающих занятий с введением интерактива...
                            <!-- Для меня важно заинтересовать ребёнка на уроке, чтобы каждый был вовлечён и погружён в атмосферу!-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 40px;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="redh2">Как проходят наши уроки</h2>
                        <p class="px18">Особенность онлайн-занятий Полиглотиков &ndash; в активном применении
                            коммуникативного подхода.
                            Это значит &ndash; никакой зубрёжки! Обучение происходит только в процессе общения детей с
                            педагогом, игр, демонстрации предметов, создания поделок.</p>
                        <p class="px18"><span class="strong-black">Наши уроки проходят по принципу «One person &ndash; one language». Педагог не использует русскую  речь для пояснений. Более того, некоторые наши преподаватели являются носителями языка и совсем не говорят по-русски. Таким образом, единственное средство общения на занятии &ndash;  английский язык.</span>
                        </p>
                        <p class="px18">Свою речь преподаватель сопровождает выразительной мимикой, жестами,
                            иллюстрациями. Благодаря этому ребёнок очень быстро начинает догадываться о смысле
                            высказываний и легко воспринимает новые слова и грамматические конструкции. Такой метод
                            обучения позволяет освоить иностранный язык, как родной.</p>
                        <p class="px18"><span class="strong-black">Обучая детей, мы опираемся на законы нейропедагогики &ndash; активно вовлекаем правое полушарие мозга ребёнка в процесс усвоения иностранного языка. Всем известно, что правое полушарие отвечает за образы и эмоции.</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid blue-wave-top" style="margin-top: -7px;"></div>
        <div class="container-fluid blueback about-fr" style="text-align:left;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="greenh2">Чтобы дети легко запоминали новые слова, наши педагоги:</h2>

                    </div>
                </div>
                <div class="row bird-pres">
                    <div class="col-12 col-sm-4">
                        <img class="" src="@/assets/hometeacher/images/birdushka.png">
                        <p style="margin-top: 25px;">Рисуют с ними в рабочих тетрадях</p>
                    </div>

                    <div class="col-12 col-sm-4">
                        <img class="" src="@/assets/hometeacher/images/garant-img-8.png">
                        <p style="margin-top: 25px;">Загадывают им загадки</p>
                    </div>

                    <div class="col-12 col-sm-4">
                        <img class="" src="@/assets/hometeacher/images/garant-img-5.png">

                        <p>Включают песенки и мультфильмы на английском языке, чтобы удержать внимание детей и вместе
                            повторить новые темы.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 40px;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <p class="px18">Обучение проходит в атмосфере доброй игры. Известно, что в спокойной обстановке
                            дети гораздо лучше воспринимают новую информацию, поэтому наши специалисты общаются с ними
                            ласково, поощряя к развитию. Очень важно, чтобы и родители поддерживали своего ребёнка и не
                            требовали от него немедленного результата.</p>
                        <p class="px18"><span class="strong-black">Следует помнить, что наша методика предуматривает постепенное накопление языковых знаний без стресса и напряжения.  Наберитесь терпения, доверьтесь мастерству наших педагогов и результат не заставит себя ждать!</span>
                        </p>
                        <p class="px18">Авторские программы в Полиглотиках построены таким образом, что заканчивая один
                            курс, учащийся переходит к другому, совершенствуя и улучшая навыки. Курс «Preschool English
                            1» рассчитан на год обучения. Освоив его программу, ваш ребёнок может продолжить обучение на
                            следующей ступени &ndash; «<a
                                    href="https://poliglotiki.com/home-teacher/preschool-english-2">Preschool English
                                2</a>».</p>

                        <h3 class="redh3" style="text-align: center;">Быть Полиглотиком просто: запишитесь на занятия
                            прямо сейчас и маленькими шагами двигайтесь к большой цели вместе с нами!</h3>
                    </div>
                </div>

                <div class="row about-center">
                    <div class="col-12" style="padding-top: 40px;">
                        <a href="/home-teacher/subscription/order/1/6440" class="knpk">Записаться на курс</a>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-top: 30px;"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2><span class="strong-black">Отзывы об онлайн-уроках</span></h2>
                        <p>&nbsp;</p>
                    </div>
                </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nataliya-yuferova.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">24.05.2021</span>
                  <span class="nameotzyv">Наталия Юферова <a href="https://vk.com/id4037847" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года. Дочке было 5 лет, ранее знакомства с английским языком не было. На Полиглотиков наткнулась случайно: заинтересовал он-лайн формат обучения при многообразии уроков. Я всегда за обучение в формате игр, а тут и music class, и story time, и art class. На первый урок попали к Виктории, с нами были ещё несколько ребят, которые уже ориентировались в английском. Хочу сразу сказать огромное спасибо преподавателям за их чуткость к детям, заинтересованность в их обучении, благожелательность, жизнерадостность и внимание! Спасибо за то, что прививаете любовь к языкам нашим детям! Сразу скажу, что дочка первые занятия не понимала и не запоминала слова, но была увлечена, с нетерпением ждала уроков, и правильный ответ для неё был маленькой победой! Мне в свою очередь было очень удобно он-лайн обучение: мы были на дистанционной работе, а ребёнка можно было просто посадить рядом и подсказывать при необходимости. Сейчас это также удобно, потому что если мы не успеваем, то подключиться к уроку дочка может или сама, или бабушка поможет, не нужно никуда собираться и ехать. А иногда я занимаюсь домашними делами, а ребёнок рядом занимается. При этом мы, родители, знаем, что дети проходят, можем помочь, повторить слова, вводить их в повседневный разговор, скачать изучаемые песни, чтобы вместе попеть, почитать книжку на русском, ту, которую читали на английском на уроках (это просто огромный плюс). А ещё дети неохотно отрываются от своих игр и маленьких дел даже ради любимых занятий, а тут можно даже игрушки не убирать, просто переместиться за стол, а по окончании вернуться в игру. По самим урокам: мне нравится наполненность, дозированность информации в сочетании с переменками в виде песенок с движениями-дети не успевают ни заскучать, ни устать. Поделки с art класса мы носили в садик, дарили в виде новогодних подарков родственникам - темы поделок всегда актуальны. Ещё раз спасибо всем нашим преподавателям! И за обратную связь! Как результат занятий - дочка может пройти этап знакомства, ответить на вопросы о любимых игрушках/блюдах/цветах, рассказать о погоде и описать человека, а ещё спеть пару песенок на английском, но под фонограмму :))) и выдать слова, которые мы вроде не проходили, но встречали на уроках story time. Надеюсь, что дальше будет только увлекательнее и интереснее.</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nadya-brandaus.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">21.05.2021</span>
                  <span class="nameotzyv">Nadya Brandaus <a href="https://vk.com/id294529857" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника. Для меня удивительно, почти час ребёнок погружен в процесс, слушает и отвечает с удовольствием. Преподаватели - просто волшебники! Моя дочь очень застенчива, легко отвлекается, до этого мы пробовали несколько курсов, где не получалось. «Полиглотики» придали ребёнку самоуверенности. Дочка выучила много новых слов и выражений, стала разговаривать и напевать на английском. Мы очень рады, что нашли вас! Удачи всем!</span>

                </div>
              </div>

              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/no-avatar-1.png"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">20.05.2021</span>
                  <span class="nameotzyv">Olia Foro <a href="https://vk.com/o.foro" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ, но у ребенка пропадал интерес после нескольких уроков. Но попав в эту школу, мы остаёмся тут на долго. Прекрасные преподаватели, которые умеют увлечь маленьких непосед, служба поддержки, которая всегда на связи и оперативно отвечает на все запросы, огромное количество различных занятий. Ребенок с нетерпением ждет каждого урока, всегда есть обратная связь, групповые занятия проходят очень весело и продуктивно. Всегда учитываются пожелания клиента. Очень рады быть с Вами!!!</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/vera-kondrateva.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">18.05.2021</span>
                  <span class="nameotzyv">Вера Кондратьева <a href="https://www.facebook.com/profile.php?id=100008304612517" target="_blank">facebook.com</a></span><br>

                  <span class="textotzyv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей, ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу https://poliglotiki.com для изучения англ языка.<br>
                      Уроки проходят с понедельника по субботу 2 раза в день, группы представлены разные от 3 до 17 лет, причем мы живем в Доминикане и по нашему часовому поясу занятия также проходят в 10,11.12,13 по местному, т.е. вечером по Москве. Занятия классные, в игровой форме, для начинающих деток проходит обучение в форме игры, занятий по рисованию, чтение сказок, поем песенки и ВСЕ на англ. Для нас это выход, ребенок общается с другими детьми, постоянно слушает англ речь. Цены не просто доступные, а супердоступные. Первые 3 дня бесплатно, смотрите, пробуете. Мы намучались выбирая разные платформы и способы обучения, многие просто берут неадекватные деньги за те же самые услуги, устраивает все от качества,формы преподования, до цены и внеурочного общения с менеджерами. Это лучшая платформа, что мы встречали по изучению англ языка, там есть и другие языки, но мы пока учим англ. Хотела поделиться с теми, кто также как мы давно ищет нечто подобное и не может найти, я как мать двоих детей, обучающая своих детей дома, понимаю и знаю как это тяжело, поэтому решила сделать здесь пост, кому то надеюсь очень поможет, а вы когда нибудь поделитесь тоже чем то интересным и так общими усилиями будем помогать друг друг в этом нелегком дете воспитания наших деток. Я не менеджер ответов на вопросы не даю, если есть вопросы пишите им лично, сайт я указала. Всем хорошего дня!!</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">27.02.2021</span>
                  <span class="nameotzyv">Елена Серебрякова <a href="https://vk.com/id426090428" target="_blank"
                                                               rel="nofollow">vk.com</a></span><br>

                  <span class="textotzyv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского. Дети всегда могут обратиться и на русском, и на английском языках. В занятиях красочные задания, песни; преподаватели всегда интересуются качеством связи, чтобы слышать всех учеников. Поправляют ошибки вежливо, без придирок, всегда обращают внимание на правильность произношения. Занятий много в расписании, можно посещать любые. Преподаватели знакомятся с каждым ребенком, нет чувства, что занимаешься с чужим человеком. К каждой теме, есть тематическая песня. На музыкальных занятиях изучают песни, по строчкам проговаривая текст.</span>
                </div>
              </div>

              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/marina-fedorina.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">22.01.2021</span>
                  <span class="nameotzyv">Марина Федорина <a href="https://vk.com/id42068522" target="_blank"
                                                             rel="nofollow">vk.com</a></span><br>

                  <span class="textotzyv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от  #полиглотиков.<br>
                    Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре в школу, а учитель английского заболела, а потом и мы все заболели. Начала я искать, где можно английский подтянуть. Все заведения по дополнительному образованию в городе закрыты из-за карантина. Наткнулась на #полиглотиков, там как раз была акция 2 недели бесплатного обучения с онлайн учителем по зуму. Решили попробовать, вроде, понравилось. Миша «ходит» в группу для младших школьников. Вначале слова учили по темам, сейчас грамматика пошла. Втянулся, раньше спрашивал, когда занятия, сейчас сам уже всё расписание выучил, лучше меня знает. В школе тоже пятёрки «пошли» по английскому.<br>
                    Среднего из садика тоже на карантин «высадили», кружки все на дистанционном обучении, только задания присылают. А когда с ним все занятия выполнять… Хотелось, чтобы сам иногда занимался. Решили с Максимом тоже английский начать учить. Записала его в группу для начинающих возраст 5-6 лет. И не пожалела. Сейчас, через 3 месяца уже отвечает на вопросы о себе, о семье может немного рассказать, цвета знает и счёт до 10. Хотя до этого вообще английский не учил. Нравится, как преподаватель с ними работает, слова наглядно на картинках плюс подписаны на английском идёт зрительное и слуховое запоминание. Песенку в начале каждого занятия поют, уже вся семья выучила) Игры разнообразные на закрепление слов. У Максима азарт такой во время игры, первый раз даже не поняла, почему он у меня там кричит во время занятия.<br>
                    Единственное, мне кажется, Максиму не хватает начальных знаний, типа изучение алфавита. И время не всегда удобное, у нас 2 часа разница с московским, занятия иногда в 9 вечера. На курсе 2 варианта занятия днём в 12-13 и вечером в 8-9 вечера. Когда сидим дома, занимаемся днём, когда в садик ходим, то вечером. Хотя что Миша, что Максим готовы на все занятия ходить… и днём и вечером.<br>
                    Программа, в которой проходят занятия простая. 6-летний сын сам разобрался, что где включать.<br>
                    Учителя замечательные, хвалят, подбадривают, стараются всем внимания уделить. В дневных группах мало народа, иногда 1-2 человека занимаются, получается индивидуальное занятие, в вечерних больше — по 6-8 в среднем. В общем, всем, кто хочет поднятуть ребёнка по английскому, или начать изучать очень советую онлайн-курс от #полиглотиков «OnlineTeacher».<br>
                    Ах, да, ещё кроме основных занятий есть дополнительные «Арт класс», «мьюзик класс» и «стори тайм», где дети мастерят, рисуют, поют песни и слушают истории. Занятия проходят легко и весело. Спасибо всем преподавателям школы #полиглотиков.</span>
                </div>
              </div>
            </div>
        </div>
        <Entry/>

    </div>
</template>
<script>

    import Entry from "./Entry";
    import TimetableStatic from "./TimetableStatic";
    import CourseStatic from "./CourseStatic";


    export default {
        components: {
            CourseStatic,
            TimetableStatic,
            Entry,
        },
        name: 'PreschoolEnglish1',

        data: function () {
            return {
                title: null,
            }
        },

        metaInfo() {
            return {
                title: 'Курс групповых онлайн-занятий Preschool English 1',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: '☝☝☝☝☝ «OnlineTeacher» – это домашний педагог, для встречи с которым не нужно никуда идти!'
                    }
                ]
            }
        },

        mounted() {
        },

        methods: {}
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
<style lang="scss" scoped>
    .razuchim {
        background-image: url(~@/assets/hometeacher/images/razuchim.png);
        height: 458px;
        background-position: top;
        background-repeat: no-repeat;
        margin-top: -2px;
        margin-bottom: 40px;
    }

    .skill-wrapper {
        position: relative;
    }

    .skill-text {
        font-family: Manrope Bold;
        font-size: 18px;
        line-height: 18px;
        border: 3px solid;
        border-radius: 50%;
        position: absolute;
        text-align: center;
        padding-left: 20px;
        padding-right: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-line-pack: center;
        align-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .skill-text span {
        margin: auto 0;
    }

    .skill-text-1 {
        color: #b01ced;
        border-color: #b01ced;
        height: 180px;
        width: 180px;
        left: 153px;
        top: 44px;
    }

    .skill-text-2 {
        color: #00b4f1;
        border-color: #00b4f1;
        height: 120px;
        width: 120px;
        top: 185px;
        left: 328px;
    }

    .skill-text-3 {
        color: #00963f;
        border-color: #00963f;
        height: 150px;
        width: 150px;
        top: 284px;
        left: 167px;
    }

    .skill-text-4 {
        color: #33c416;
        border-color: #33c416;
        height: 150px;
        width: 150px;
        top: 1px;
        left: 598px;
    }

    .skill-text-5 {
        color: #fa8500;
        border-color: #fa8500;
        height: 120px;
        width: 120px;
        top: 198px;
        left: 628px;
    }

    .skill-text-6 {
        color: #0450c3;
        border-color: #0450c3;
        height: 180px;
        width: 180px;
        top: 65px;
        left: 767px;
    }

    .skill-text-7 {
        color: #ed1c24;
        border-color: #ed1c24;
        height: 150px;
        width: 150px;
        top: 275px;
        left: 770px;
    }

    .skill-text-8 {
        color: #ed1c24;
        border-color: #ed1c24;
        height: 150px;
        width: 150px;
        top: -5px;
        left: 329px;
    }

    .vidos {
        width: 100%;
        height: 623px;
    }

    .sertifikat {
        max-width: 160px;
    }

    .px18 {
        color: #000;
    }

    .land-t-h2 {
        font-size: 24px;
        color: #4f4d5c;
    }

    .centers-text {
        text-align: center;
    }

    .teacher-krug {
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 2px 5px 3px #0003;
    }

    .teacher-name {
        margin-top: 36px;
        margin-bottom: 15px;
    }

    .teacher-name a {
        font-family: Manrope Bold;
        font-size: 16px;
        color: #000000;
        text-decoration: underline;
    }

    .teacher-name a:hover {
        text-decoration: none;
        color: #5ab947;
    }

    .speach {
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 50px;
        color: #000;
    }

    .bird-pres {
        margin-top: 50px;
        min-height: 200px;
    }

    .bird-pres p {
        font-size: 18px;
        font-family: "Manrope Bold";
        padding-left: 110px;
        color: #000000;
    }

    .bird-pres img {
        float: left;
        margin-right: 10px;
        margin-bottom: 25px;
    }

    .knpk {
        border-radius: 7px;
        font-family: Manrope Bold;
        background: -webkit-gradient(linear, left bottom, left top, from(#058bca), to(#00bdfd));
        /*background: #00bcfb;*/
        font-size: 18px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0px 3px 3px #0003;
        text-decoration: none;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    }

    .knpk:hover {
        color: #fff;
        background: #058bca;
    }

    .dateotzyv, .nameotzyv, .textotzyv {
        color: #000;
    }


    @media (max-width: 1024px) {
        .skill-text-1 {
            left: 107px;
        }
        .skill-text-2 {
            left: 266px;
        }
        .skill-text-8 {
            display: none;
        }
        .vidos {
            height: 525px !important;
        }
    }

    @media (max-width: 960px) {
        .skill-text-1 {
            left: 0px;
        }
        .skill-text-2 {
            left: 135px;
        }
        .skill-text-3 {
            left: 0px;
        }
        .skill-text-4 {
            left: 390px;
        }
        .skill-text-5 {
            left: 400px;
        }
        .skill-text-6 {
            left: 530px;
        }
        .skill-text-7 {
            left: 525px;
        }
        .vidos {
            height: 390px !important;
        }
    }

    @media (max-width: 640px) {
        .razuchim {
            background-image: url(~@/assets/hometeacher/images/skills-boy.png);
            margin-bottom: 0px;
        }
        .skill-text-1 {
            width: 150px;
            height: 150px;
            top: 0px !important;
            left: 40px !important;
        }
        .skill-text-2 {
            left: 20px !important;
            top: 125px !important;
        }
        .skill-text-3 {
            left: 33px !important;
            top: 215px !important;
        }
        .skill-text-4 {
            left: 328px !important;
            width: 140px;
            height: 140px;
            top: 0px !important;
        }
        .skill-text-5 {
            left: 300px !important;
        }
        .skill-text-6 {
            left: 358px !important;
            width: 130px;
            height: 130px;
            top: 108px !important;
        }
        .skill-text-7 {
            left: 165px !important;
            top: 230px !important;
        }
        .vidos {
            height: 287px !important;
        }
    }

    @media (max-width: 481px) {
        .skill-text-1 {
            left: 20px !important;
        }
        .skill-text-4 {
            left: 295px !important;
        }
        .skill-text-6 {
            left: 315px !important;
        }
        .skill-text-5 {
            top: 230px !important;
        }
        .vidos {
            height: 258px !important;
        }
    }

    @media (max-width: 400px) {
        .skill-text-1 {
            width: 120px;
            height: 120px;
            left: 15px !important;
        }
        .skill-text-2 {
            top: 108px !important;
        }
        .skill-text-3 {
            left: 19px !important;
            width: 130px;
            height: 130px;
        }
        .skill-text-4 {
            width: 125px;
            height: 125px;
            left: 243px !important;
        }
        .skill-text-5 {
            left: 240px !important;
        }
        .skill-text-6 {
            width: 120px;
            height: 120px;
            left: 243px !important;
        }
        .skill-text-7 {
            width: 130px;
            height: 130px;
            left: 140px !important;
        }
        .vidos {
            height: 214px !important;
        }
    }

    @media (max-width: 375px) {
        .vidos {
            height: 202px !important;
        }
    }

    @media (max-width: 320px) {
        .vidos {
            height: 180px;
        }
        .skill-text-4 {
            left: 194px !important;
        }
        .skill-text-6 {
            left: 193px !important;
        }
        .skill-text-7 {
            left: 113px !important;
        }
        .skill-text-5 {
            left: 200px !important;
        }
        .skill-text-1, .skill-text-2, .skill-text-3 {
            left: 0px !important;
        }
    }

    @media (max-width: 991px) {
        .skill-text-1 {
            left: 0px;
            top: 0px;
        }
        .skill-text-2 {
            left: 190px;
            top: 0px;
        }
        .skill-text-3 {
            left: 375px;
            top: 0px;
        }
        .skill-text-4 {
            left: 485px;
            top: 110px;
        }
        .skill-text-5 {
            left: 50px;
            top: 170px;
        }
        .skill-text-6 {
            left: 450px;
            top: 250px;
        }
        .skill-text-7 {
            left: 50px;
        }
        .skill-text-8 {
            left: 500px;
            top: 335px;
        }
    }

    @media (max-width: 767px) {
        .skill-text-3 {
            left: 310px;
        }
        .skill-text-4 {
            left: 335px;
            top: 290px;
        }
        .skill-text-6 {
            left: 335px;
            top: 155px;
        }
        .skill-text-7 {
            left: 0px;
            top: 300px;
        }

    }

    @media (max-width: 575px) {
        .blue-wave-top, .blue-wave-bottom, .green-wave-bottom, .green-wave-top {
            background-size: auto;
        }
        .topchik h1 {
            margin-left: 15px;
        }
        .group {
            float: none;
            margin-left: 15px;
        }
        .prezent {
            text-align: center;
        }
        .prezent h2 {
            margin-left: 15px;
            margin-right: 15px;
            text-align: left;
        }
        .prezent h3 {
            margin-left: 15px;
            margin-right: 15px;
            text-align: left;
        }
        .prezent p {
            text-align: left;
        }
        .prezent img {
            float: none;
            margin-left: 15px;
            margin-top: 15px;
            margin-bottom: 30px;
        }
        .orange-knp {
            padding: 20px 30px;
        }
        .white-bg h2 {
            margin-left: 15px;
        }
        .nazan {
            margin-left: 0px;
        }
        .skill-wrapper img {
            width: 133px;
            margin-left: 0px;
            margin-top: 264px;
        }
        .urok {
            height: 755px;
        }
        .skill-text-4 {
            left: 47%;
            top: 0px;
        }
        .skill-text-2 {
            left: 3%;
            top: 150px;
        }
        .skill-text-7 {
            width: 130px;
            height: 130px;
            left: 10px;
            top: 300px;
        }
        .skill-text-3 {
            left: 49%;
            top: 180px;
        }
        .skill-text-7 {
            left: 49%;
            top: 535px;
        }
        .skill-text-5 {
            left: 28px;
            top: 215px;
        }
        .skill-text-8 {
            top: 635px;
            left: 50px;
        }
        .skill-text-6 {
            left: 62%;
            top: 375px;
        }
        .mbpt {
            padding-bottom: 10px !important;
        }
        .vidos {
            height: 311px;
            margin-left: 2px;
        }
        .speach {
            margin-left: 10px;
            margin-right: 10px;
        }
    }

</style>
